<script setup>
// One conversation of the SLA report as a row of the kit's table.
import { computed } from 'vue';
import UserAvatar from 'dashboard/components-next/polaris/cards/UserAvatar.vue';
import CardLabels from 'dashboard/components/widgets/conversation/conversationCardComponents/CardLabels.vue';
import {
  TableCell,
  TableRow,
} from 'dashboard/components-next/polaris/ui/table';
import SLAViewDetails from './SLAViewDetails.vue';

const props = defineProps({
  slaName: {
    type: String,
    required: true,
  },
  conversationId: {
    type: Number,
    required: true,
  },
  conversation: {
    type: Object,
    required: true,
  },
  slaEvents: {
    type: Array,
    default: () => [],
  },
});

const conversationLabels = computed(() => {
  return props.conversation.labels
    ? props.conversation.labels.split(',').map(item => item.trim())
    : [];
});

const routerParams = computed(() => ({
  name: 'inbox_conversation',
  params: { conversation_id: props.conversationId },
}));
</script>

<template>
  <TableRow>
    <TableCell class="px-4">
      <div
        class="flex min-w-40 max-w-64 flex-wrap items-center gap-x-2 gap-y-1 xl:max-w-96"
      >
        <router-link
          :to="routerParams"
          class="font-medium text-polaris-foreground underline decoration-polaris-foreground/40 underline-offset-4 hover:decoration-polaris-foreground"
        >
          {{ `#${conversationId}` }}
        </router-link>
        <span class="text-polaris-muted-foreground">
          {{ $t('SLA_REPORTS.WITH') }}
        </span>
        <span class="min-w-0 truncate capitalize">
          {{ conversation.contact.name }}
        </span>
        <CardLabels
          v-if="conversationLabels.length"
          class="min-w-0 basis-full"
          :conversation-id="conversationId"
          :conversation-labels="conversationLabels"
        />
      </div>
    </TableCell>
    <TableCell class="max-w-56 whitespace-normal break-words px-4 capitalize">
      <div class="min-w-40">{{ slaName }}</div>
    </TableCell>
    <TableCell class="max-w-56 px-4">
      <div v-if="conversation.assignee" class="flex min-w-0 items-center gap-2">
        <UserAvatar
          :name="conversation.assignee.name"
          :src="conversation.assignee.thumbnail || ''"
          :size="24"
          decorative
        />
        <span class="truncate">{{ conversation.assignee.name }}</span>
      </div>
      <span v-else class="text-polaris-muted-foreground">
        {{ $t('CSAT_REPORTS.NO_AGENT') }}
      </span>
    </TableCell>
    <TableCell class="px-4 text-end">
      <SLAViewDetails :sla-events="slaEvents" />
    </TableCell>
  </TableRow>
</template>
